// extracted by mini-css-extract-plugin
export default {"custom-vars-styles":"custom-vars-styles__gBuAW"};